var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_1733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23C9.21523 23 6.54451 21.8938 4.57538 19.9246C2.60625 17.9555 1.5 15.2848 1.5 12.5C1.5 9.71523 2.60625 7.04451 4.57538 5.07538C6.54451 3.10625 9.21523 2 12 2C14.7848 2 17.4555 3.10625 19.4246 5.07538C21.3938 7.04451 22.5 9.71523 22.5 12.5C22.5 15.2848 21.3938 17.9555 19.4246 19.9246C17.4555 21.8938 14.7848 23 12 23ZM12 24.5C15.1826 24.5 18.2348 23.2357 20.4853 20.9853C22.7357 18.7348 24 15.6826 24 12.5C24 9.3174 22.7357 6.26516 20.4853 4.01472C18.2348 1.76428 15.1826 0.5 12 0.5C8.8174 0.5 5.76516 1.76428 3.51472 4.01472C1.26428 6.26516 0 9.3174 0 12.5C0 15.6826 1.26428 18.7348 3.51472 20.9853C5.76516 23.2357 8.8174 24.5 12 24.5Z",
    fill: "#222F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5C12.1989 6.5 12.3897 6.57902 12.5303 6.71967C12.671 6.86032 12.75 7.05109 12.75 7.25V11.75H17.25C17.4489 11.75 17.6397 11.829 17.7803 11.9697C17.921 12.1103 18 12.3011 18 12.5C18 12.6989 17.921 12.8897 17.7803 13.0303C17.6397 13.171 17.4489 13.25 17.25 13.25H12.75V17.75C12.75 17.9489 12.671 18.1397 12.5303 18.2803C12.3897 18.421 12.1989 18.5 12 18.5C11.8011 18.5 11.6103 18.421 11.4697 18.2803C11.329 18.1397 11.25 17.9489 11.25 17.75V13.25H6.75C6.55109 13.25 6.36032 13.171 6.21967 13.0303C6.07902 12.8897 6 12.6989 6 12.5C6 12.3011 6.07902 12.1103 6.21967 11.9697C6.36032 11.829 6.55109 11.75 6.75 11.75H11.25V7.25C11.25 7.05109 11.329 6.86032 11.4697 6.71967C11.6103 6.57902 11.8011 6.5 12 6.5Z",
    fill: "#222F3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_1733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.cb6e1dfe131b7862ef41785a8e461ec6.svg";
export { ForwardRef as ReactComponent };